import { Theme } from '@mui/material/styles'

const muiBackDrop = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        // backgroundColor: 'rgba(0,0,0,.4)',
      }
    }
  }
}

export default muiBackDrop
